import api from './api'

export type SafetyEventType = 'PANIC' | 'MAN_DOWN' | 'DURESS' | 'CHECKIN_MISSED'
export type SafetyEventStatus = 'OPEN' | 'ACKNOWLEDGED' | 'RESOLVED'

export interface SafetyEvent {
    id: number
    userId: string
    callsign?: string
    type: SafetyEventType
    status: SafetyEventStatus
    detail?: string
    createdAt: string
}

interface AlertReq { lat?: number; lon?: number; detail?: string }

export interface MedevacBody {
    lat?: number; lon?: number
    line2FreqCallsign?: string
    line3PatientsPrecedence?: string
    line4SpecialEquipment?: string
    line5PatientsType?: string
    line6Security?: string
    line7MarkingMethod?: string
    line8NationalityStatus?: string
    line9NbcTerrain?: string
}

export const safetyService = {
    panic: async (r?: AlertReq): Promise<SafetyEvent> => (await api.post<SafetyEvent>('/api/v1/safety/panic', r || {})).data,
    manDown: async (r?: AlertReq): Promise<SafetyEvent> => (await api.post<SafetyEvent>('/api/v1/safety/man-down', r || {})).data,
    duress: async (r?: AlertReq): Promise<SafetyEvent> => (await api.post<SafetyEvent>('/api/v1/safety/duress', r || {})).data,
    open: async (): Promise<SafetyEvent[]> => (await api.get<SafetyEvent[]>('/api/v1/safety/open')).data,
    ack: async (id: number): Promise<SafetyEvent> => (await api.post<SafetyEvent>(`/api/v1/safety/events/${id}/ack`)).data,
    resolve: async (id: number): Promise<SafetyEvent> => (await api.post<SafetyEvent>(`/api/v1/safety/events/${id}/resolve`)).data,
    startLoneWorker: async (intervalMinutes: number) => (await api.post('/api/v1/safety/lone-worker/start', { intervalMinutes })).data,
    checkin: async () => { await api.post('/api/v1/safety/lone-worker/checkin') },
    endLoneWorker: async () => { await api.post('/api/v1/safety/lone-worker/end') },
    medevac: async (body: MedevacBody) => (await api.post('/api/v1/safety/medevac', body)).data,
}
